import React, { useState, useEffect } from 'react';
import { Table, message, Spin, Tag, Button } from 'antd';
import { ragApi, Article } from '../services/ragApi';

const DocumentList: React.FC = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchArticles = async () => {
    setLoading(true);
    try {
            const response = await ragApi.getArticles();
      setArticles(response.documents || []);
    } catch (error) {
            console.error('Failed to fetch articles:', error);
      message.error('無法載入文檔列表，請稍後再試');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  const columns = [
    {
      title: '標題',
      dataIndex: 'article_title',
      key: 'article_title',
      render: (text: string) => text || '無標題',
    },
    {
      title: '操作',
      key: 'action',
      render: (_: any, record: Article) => (
        <Button
          type="primary"
          href={record.article_url || '#'}
          target="_blank"
          rel="noopener noreferrer"
          disabled={!record.article_url}
        >
          查看原文
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>文檔管理</h2>
        <Button onClick={fetchArticles} type="primary">刷新列表</Button>
      </div>
      <Spin spinning={loading}>
        <Table 
          dataSource={articles} 
          columns={columns} 
          rowKey="id" 
          pagination={{ pageSize: 10 }}
        />
      </Spin>
    </div>
  );
};

export default DocumentList;
